import { useGetProjectsToManageQuery } from '../api/adminProjectsApiSlice';

export const useManageProjectsDataGridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetProjectsToManageQuery> => {
  return useGetProjectsToManageQuery();
};
